<div class="router-bar">

  <div class="report-button header-report-button">
    <button mat-button (click)="createReport()">Create Report</button>
  </div>

  <div class="input-ratio-block" *ngIf="!ratesLoading">
    <span class="ratio-title">Labor Cost:</span>
    <p-inputNumber #tagAmount [(ngModel)]="rates.value.directLaborCost" mode="currency" currency="USD"
                   (onInput)="topRationBarLabor($event)" (click)="focusInput($event)"
                   locale="en-US" [minFractionDigits]="2">
    </p-inputNumber>
  </div>

  <div class="input-ratio-block" *ngIf="!ratesLoading">
    <span class="ratio-title">Overhead Cost:</span>
    <p-inputNumber #ratioAmount [(ngModel)]="rates.value.overheadLaborCost" mode="currency" currency="USD"
                   (onInput)="topRationBarOverhead($event)" (click)="focusInput($event)"
                   locale="en-US" [minFractionDigits]="2">
    </p-inputNumber>
  </div>

  <div class="space-block">

  </div>

  <div class="input-ratio-block report-calendar">
    <span class="ratio-title">From:</span>

    <p-calendar [(ngModel)]="reportFromDate" view="date" [tabindex]="-1" type="date" dateFormat="M d, yy"
                name="startDate" placeholder="Date" [showIcon]="false" [ngModelOptions]="{standalone: true}"
                styleClass="report-calendar" (ngModelChange)="dateChange()" [showButtonBar]="true" (onShow)="blurActiveElement()">
    </p-calendar>
  </div>

  <div class="input-ratio-block report-calendar">
    <span class="ratio-title">To:</span>

    <p-calendar [(ngModel)]="reportToDate" view="date" [tabindex]="-1" type="date" dateFormat="M d, yy"
                name="startDate" placeholder="Date" [showIcon]="false" [ngModelOptions]="{standalone: true}"
                styleClass="report-calendar" (ngModelChange)="dateChange()" [showButtonBar]="true" (onShow)="blurActiveElement()">
    </p-calendar>
  </div>

  <div class="search-bar">
    <span class="p-input-icon-right">
      <i class="pi pi-times cross-icon" (click)="resetSearch()" *ngIf="searchString?.length > 0"></i>
      <input pInputText BlockLateralArrowNavigation class="text-input" autocomplete="off" placeholder="Search Projects"
             type="text"
             [(ngModel)]="searchString" name="name" (input)="topSearchBar()">
    </span>
  </div>
</div>


<div class="reports-middle">
  <div class="report header-report">
    <div class="number-block">
      <div class="number-name">Number</div>
    </div>
    <div class="project-block">
      <div class="project-name">Name</div>
    </div>
    <div class="project-price">
      <div class="price-tile">Created</div>
    </div>
    <div class="project-price">
      <div class="price-tile">Total Project Cost</div>
    </div>
    <div class="project-price">
      <div class="price-tile">Project Sale Price</div>
    </div>
    <div class="project-price">
      <div class="price-tile">Net</div>
    </div>
  </div>

  <div class="reports-block loading-reports-block" *ngIf="reportsLoading">
    <lib-progress-spinner></lib-progress-spinner>
  </div>

  <div class="reports-block" *ngIf="!reportsLoading">
    <div class="report">
      <p-accordion [activeIndex]="openedReports" (onOpen)="openTab($event)" (onClose)="closeTab($event)"
                   [multiple]="true">
        <p-accordionTab class="report-tab"
                        *ngFor="let overallReport of overallReports; index as i">
          <p-header>
            <div class="number-block">
              <div class="report-name">{{overallReport.projectDTO.number}}</div>
            </div>
            <div class="project-block">
              <div class="project-name">{{overallReport.projectDTO?.name}}</div>
            </div>
            <div class="project-price">
              <div class="price-tile">{{overallReport.createdTime | date: 'MMM dd, yyyy'}}</div>
            </div>
            <div class="project-price">
              <div class="price-title">Total Cost: ${{overallReport.totalCost | number: '1.2-2'}}</div>
            </div>
            <div class="project-price">
              <div class="price-title">Sale Price: ${{overallReport.estimatePrice | number: '1.2-2'}}</div>
            </div>
            <div class="project-price">
              <div class="price-tile">Net:
                ${{(overallReport.estimatePrice - overallReport.totalCost) | number: '1.2-2'}}</div>
            </div>
          </p-header>

          <div class="report-cabinets-body-block">
            <ng-container *ngIf="overallReport.items?.length > 0">

              <app-project-overall-price-table [reportLines]="overallReport.items" [project]="overallReport.projectDTO"
                                               (addLine)="addLine($event, i)"
                                               (itemEdited)="itemEdited(i)"></app-project-overall-price-table>

              <div class="report-cabinets-bottom-block">
                <div class="report-cabinets-num total-cost">
                  <div class="report-total-label">Total Project Cost:</div>
                  <span class="report-total-num">${{overallReport.totalCost | number: '1.2-2'}}</span>
                </div>

                <div class="report-cabinets-num sale-cost">
                  <div class="report-total-label">Project Sale Price:</div>

                  <p-inputNumber class="project-cost-edit"
                                 [(ngModel)]="overallReport.estimatePrice"
                                 mode="currency"
                                 currency="USD"
                                 locale="en-US"
                                 [minFractionDigits]="2"
                                 (ngModelChange)="itemEdited($event)">
                  </p-inputNumber>

                  <!-- <span class="report-total-num">${{overallReport.estimatePrice | number: '1.2-2'}}</span>-->
                </div>

                <div class="report-cabinets-num net-num">
                  <div class="report-total-label">Net:</div>
                  <span
                    class="report-total-num">${{(overallReport.estimatePrice - overallReport.totalCost) | number: '1.2-2'}}</span>
                </div>
              </div>
              <div class="buttons-block">
                <button mat-button class="report-button delete-report"
                        (click)="deleteReport(overallReport, i)">
                  <span *ngIf="deleteLoading !== overallReport.id">Delete Report</span>
                  <lib-mini-progress-spinner *ngIf="deleteLoading === overallReport.id">
                  </lib-mini-progress-spinner>
                </button>

                <div class="space-block"></div>

                <button mat-button class="report-button open-project"
                        (click)="openProject(overallReport.projectDTO.id)">
                  <span>Open Project</span>
                </button>

                <button mat-button class="report-button create-report" (click)="openReport(overallReport, i)">
                  <span>Save & Report</span>
                </button>

                <button mat-button class="report-button save-report" (click)="updateDate(overallReport, i)"
                        [disabled]="saveLoading === overallReport.id"
                        [ngClass]="{'disabled-button': saveLoading === overallReport.id}">
                  <span *ngIf="saveLoading !== overallReport.id">Save</span>
                  <lib-mini-progress-spinner *ngIf="saveLoading === overallReport.id">
                  </lib-mini-progress-spinner>
                </button>
              </div>
            </ng-container>
            <div *ngIf="!overallReport.items || !overallReport.items?.length"> No Items</div>
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>

  <div class="paginator-block">
    <p-paginator #orderPaginator [rows]="repElemsCount" [totalRecords]="totalRecords"
                 (onPageChange)="getReportsLazy($event.page, $event.rows)">
    </p-paginator>
  </div>
</div>

<p-confirmDialog appendTo="body" icon="pi pi-trash" styleClass="delete-report-panel">
</p-confirmDialog>
